class ReadMoreText extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.fv-desc__content');
    this.toggle = this.querySelector('.fv-desc__toggle');
    if (!this.content || !this.toggle) return;

    this.toggle.addEventListener('click', () => this.onToggle());

    this.checkOverflow();

    if ('ResizeObserver' in window) {
      this._ro = new ResizeObserver(() => {
        if (!this.classList.contains('is-expanded')) this.checkOverflow();
      });
      this._ro.observe(this);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!this.classList.contains('is-expanded')) this.checkOverflow();
      });
    }
  }

  disconnectedCallback() {
    if (this._ro) this._ro.disconnect();
  }

  checkOverflow() {
    const overflowing = this.content.scrollHeight - this.content.clientHeight > 1;
    this.toggle.hidden = !overflowing;
    if (!overflowing) this.classList.remove('is-expanded');
  }

  onToggle() {
    const expanded = this.classList.toggle('is-expanded');
    this.toggle.setAttribute('aria-expanded', String(expanded));
  }
}

if (!customElements.get('read-more-text')) {
  customElements.define('read-more-text', ReadMoreText);
}
